import Vue from "vue";
import Router from "vue-router";
import Dashboard from "../pages/Dashboard/Layout";
import Customers from "../pages/Customers/Layout";
import ListCustomers from "../pages/Customers/list";
import EditCustomer from "../pages/Customers/edit";
import { Profile, EditProfile } from "../router/imports/profile";
import { Plan, PlanList, PlanDetail } from "../router/imports/plan";
import {Report, Reports } from "../router/imports/report";
import {
  PlanResponse,
  PlanResponseDetail
} from "../router/imports/planresponse";

Vue.use(Router);
import store from "../store/store";

const router = new Router({
  routes: [
    {
      path: "/",
      name: "dashboard",
      component: Dashboard
    },
    {
      path: "/res",
      name: "planresponseroot",
      component: PlanResponse,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "schema",
          name: "planresponse",
          component: PlanResponseDetail
        }
      ]
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {
        requiresAuth: true
      },
      redirect: { name: "editprofile" },
      children: [
        {
          path: "edit",
          name: "editprofile",
          component: EditProfile
        }
      ]
    },
    {
      path: "/customers",
      name: "editcustomers",
      component: Customers,
      meta: {
        requiresAuth: true
      },
      redirect: { name: "listcustomers" },
      children: [
        {
          path: "edit/:customerid",
          name: "editcustomer",
          component: EditCustomer
        },
        { path: "list", name: "listcustomers", component: ListCustomers }
      ]
    },
    {
      path: "/plan",
      name: "plan",
      component: Plan,
      meta: {
        requiresAuth: true
      },
      redirect: { name: "planlist" },
      children: [
        {
          path: "list",
          name: "planlist",
          component: PlanList
        },
        {
          path: ":guid",
          name: "plandetail",
          component: PlanDetail
        }
      ]
    },
    {
      path: "/report",
      name: "report",
      component: Reports,
      redirect: { name: "reports" },
            children: [
        {
          path: ":guid",
          name: "report",
          component: Report
        }
      ]
    },
    { path: "*", redirect: { name: "dashboard" } }
  ]
});

let _UserLogInState = "";
async function isLoggedIn() {
  return new Promise((resolve, reject) => {
    if (store.getters.GET_USER) {
      _UserLogInState = "loggedin";
    } else if (localStorage.getItem("Token")) {
      _UserLogInState = "waitingforcheck";
    } else {
      _UserLogInState = "notloggedin";
    }
    switch (_UserLogInState) {
      case "loggedin":
        resolve(true);
        break;
      case "waitingforcheck":
        store
          .dispatch("SUBMIT_LOGIN_TOKEN")
          .then(resp => {
            resolve(true);
            _UserLogInState = "loggedin";
          })
          .catch(err => {
            _UserLogInState = "notloggedin";

            resolve(false);
          });
        break;
      case "notloggedin":
        resolve(false);
        break;
      default:
        reject(false);
    }
  });
}

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(rec => rec.meta.requiresAuth);
  if (requiresAuth) {
    isLoggedIn()
      .then(LoggedIn => {
        if (LoggedIn) {
          next();
        } else {
          alert("you need to be logged in to view this page");
          next("/");
        }
      })
      .catch(ex => {
        alert("unknown error, please refresh your browser");
        next({
          name: "frontpage", // back to safety route //
          query: { redirectFrom: to.fullPath }
        });
      });
  } else {
    next();
  }
});
export default router;
